export default __webpack_public_path__ + "static/media/Estudiantes.2467a946.png";